export enum KycError {
  MAX_ATTEMPT = 'MAX_ATTEMPT',
  KYC_CLOSED = 'KYC_CLOSED',
  REJECTED = 'REJECTED',
}
